import { BUSCAR_EMISSOES_MDFE } from '../../actions/types'

const initial = {
  emissoesMDFe: [],
  total: 0
};

export default function reducerBuscarEmissoesMdfe(state = initial, action = undefined) {
  switch (action.type) {
    case BUSCAR_EMISSOES_MDFE: {
      const emissoes = action.payload.data;
      if (emissoes) {        
        return {
          ...state,
          emissoesMDFe: emissoes.emissoesMDFe,
          total: emissoes.total
        }
      }
      return initial
    }
    default: {
      return state
    }
  }
}
